module.exports = __webpack_public_path__ + "static/media/projects_thumb_rush_site_2x.8d16c362.jpg";